type PageMetaProps = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  type?: string;
  jsonLd?: object;
};

const SITE_ORIGIN = "https://rnmka.cn";

export default function PageMeta({
  title,
  description,
  keywords,
  path,
  type = "website",
  jsonLd,
}: PageMetaProps) {
  const url = `${SITE_ORIGIN}${path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="热瓜前线" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="热瓜前线" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}